"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCaption = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function TableCaption(_a) {
    var { variant } = _a, props = __rest(_a, ["variant"]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "caption", backgroundColor: variant === 'info' ? 'info' : undefined, color: variant === 'info' ? '#fff' : undefined, py: 2, px: 3, textAlign: "center" }, props), void 0));
}
exports.TableCaption = TableCaption;
//# sourceMappingURL=index.js.map